import axios from 'axios'
import router from '@/router'
import config from '@/config'

const request = axios.create({
  baseURL: config.baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// 请求拦截
request.interceptors.request.use(
  config => {
    config.headers.token = localStorage.getItem('token')
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截
request.interceptors.response.use(
  response => {
    if (response.data?.code === 401) {
      console.log('401 错误，跳转登录页')
      localStorage.removeItem('token')
      sessionStorage.removeItem('menuList')
      sessionStorage.removeItem('dynamicMenuRoutes')
      router.push({ name: 'login' })
      return Promise.reject(new Error(response.data?.msg || '未登录'))
    }
    return response
  },
  error => {
    if (error.response?.status === 401) {
      console.log('HTTP 401 错误，跳转登录页')
      localStorage.removeItem('token')
      sessionStorage.removeItem('menuList')
      sessionStorage.removeItem('dynamicMenuRoutes')
      router.push({ name: 'login' })
    }
    return Promise.reject(error)
  }
)

request.upload = (url, file, extraData = {}) => {
  const formData = new FormData()
  formData.append('file', file)
  Object.keys(extraData).forEach(key => {
    formData.append(key, extraData[key])
  })
  return request({
    url: request.adornUrl(url),
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 请求地址处理
 */
request.adornUrl = (actionName) => {
  return config.baseUrl + actionName
}

export default request